<template>
  <div>
    <CRow>
      <CCol col="12" md="12" lg="12">
        <h4><strong>Data Peringatan</strong></h4>
        <hr />
      </CCol>
    </CRow>

    <CRow>
      <CCol col="12" md="12" lg="12">
        <b-button variant="primary" v-b-modal.modal-input-peringatan><CIcon name="cil-plus" /> Tambah Data</b-button>
      </CCol>
    </CRow>

    <CRow class="mt-3">
      <CCol col="12" md="12" lg="12">
        <CDataTable :items="items" :fields="fields" responsive sorter hover show-empty :loading="tableBusy">
          <template #actions="{ item }">
            <td>
              <b-button variant="warning" class="mr-1" v-c-tooltip.hover.click="$store.state.table.tooltipEdit" v-b-modal.modal-edit-peringatan @click="(dataPeringatan = item), (edit = !edit)">
                <CIcon name="cil-pencil" />
              </b-button>
              <b-button variant="danger" class="mr-1" v-c-tooltip.hover.click="$store.state.table.tooltipHapus" v-b-modal.modal-delete-peringatan @click="dataPeringatan = item">
                <CIcon name="cil-trash" />
              </b-button>
            </td>
          </template>
        </CDataTable>
      </CCol>
    </CRow>

    <modal-input :data="data" :dataPelanggaran="dataPelanggaran" @alertFromChild="triggerAlert($event)" />
    <modal-edit :dataPelanggaran="dataPelanggaran" :dataPeringatan="dataPeringatan" :edit="edit" @alertFromChild="triggerAlert($event)" />
    <modal-delete :dataPeringatan="dataPeringatan" @alertFromChild="triggerAlert($event)" />
  </div>
</template>
<script>
import modalInput from "./modalInput.vue";
import modalEdit from "./modalEdit.vue";
import modalDelete from "./modalDelete.vue";
export default {
  props: ["data", "change", "activetab"],
  components: {
    modalInput,
    modalEdit,
    modalDelete,
  },
  data() {
    return {
      dataPelanggaran: [],
      dataPeringatan: "",
      edit: false,
      items: [],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          sorter: true,
          class: "table-number text-center",
        },
        {
          key: "tanggal",
          label: "Tanggal Peringatan",
          sorter: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "nomorSuratPeringatan",
          label: "Nomor SP",
          sorter: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "namaPelanggaran",
          label: "Jenis Pelanggaran",
          sorter: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "keteranganPeringatan",
          label: "Keterangan",
          sorter: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "masaBerlakuPeringatan",
          label: "Masa Berlaku",
          sorter: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "tanggalKadaluarsa",
          label: "Tanggal Kadaluarsa",
          sorter: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "actions",
          label: "Actions",
          class: "table-option-3 text-center",
        },
      ],
      tableBusy: false,
    };
  },
  computed: {},
  watch: {
    "data.dataKaryawanId"(newVar, oldVar) {
      if (newVar != oldVar) {
        this.getListPeringatan();
        this.getPelanggaran();
      }
    },
    change: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getPelanggaran();
      }
    },
    activeTab(newVar) {
      if (newVar == 2) {
        this.getListPelanggaran();
        this.getPelanggaran();
      }
    },
  },
  mounted() {},
  methods: {
    async getPelanggaran() {
      let vm = this;
      let id = vm.data.dataKaryawanId;
      let listPelanggaran = await vm.$axios.get("poolPelanggaran/listPoolPelanggaranByKaryawanId/" + id);
      vm.dataPelanggaran = listPelanggaran.data.data;
    },
    async getListPeringatan() {
      let vm = this;
      let id = vm.data.dataKaryawanId;
      let listPeringatan = await vm.$axios.get("peringatan/listPeringatanByKaryawanId/" + id);
      vm.items = listPeringatan.data.data;
      for (let i = 0; i < vm.items.length; i++) {
        let x = vm.items[i];
        x.no = i + 1;
        x.tanggal = vm.$moment(x.tanggalPeringatan).format("LL");
        x.tanggalKadaluarsa = vm.$moment(x.tanggalKedaluarsaPeringatan).format("LL");
      }
      // console.log(listPeringatan, "ini peringatan");
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getListPeringatan();
    },
  },
};
</script>
